export const SUCCESS_OAUTH = 'success-oauth'
export const LOGOUT_EVENT = 'logout-event'
export const BROWSER_NOTIFICATIONS_PERMISSION = 'browser-notifications-permission'
